import React from "react"
import TableActionBar from "../../../components/layout/TableActionBar"
import AppStateStore from "../../../stores/AppStateStore"
import UploadUserDetailsFileDialog from "./UploadUserDetailsFileDialog"
import { FloatingActionButton, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IEmployeeFileSearch, IEmployeeFileDocument, IEmployeeFileSearchParams, ELoggedInUserType } from "../../../models"
import * as api from "../../../api"
import UserDetailsFilesTable from "./UserDetailsFilesTable"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"

interface IProps {
    userId: string
    loggedInUserType: ELoggedInUserType
}
interface IState {
    loading: boolean
    files: IEmployeeFileDocument[]
    searchText: string
    selectedFile: IEmployeeFileDocument
    offset: number
    limit: number
    total: number
    openUploadFileDialog: boolean
}

export default class UserDetailsFiles extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: true,
            files: [],
            searchText: "",
            selectedFile: null,
            offset: 0,
            limit: 20,
            total: 0,
            openUploadFileDialog: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getFiles()
    }

    getFiles() {
        const employeeFileSearchParams: IEmployeeFileSearchParams = {
            Page: this.state.offset / this.state.limit,
            Limit: this.state.limit,
            AdHoc: true,
        }
        this.setState({ loading: true }, () =>
            api.getEmployeeFiles(this.props.userId, employeeFileSearchParams).then(res => {
                const employeeFileSearch = res.data as IEmployeeFileSearch
                this.setState({
                    loading: false,
                    files: employeeFileSearch.Documents,
                    total: employeeFileSearch.TotalDocuments,
                    selectedFile: null
                })
            })
        )
    }

    deleteFile() {
        AppStateStore.setConfirmDialogContent({
            content: strings.Are_you_sure_you_want_to_delete_selected_file,
            confirm: () =>
                api.deleteEmployeeFile(this.state.selectedFile.Id).then(() => {
                    AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
                    this.getFiles()
                })
        })
    }

    render() {
        const searchText = this.state.searchText.toLowerCase()
        const filteredFiles = this.state.files.filter(item => item.SubType.Name.toLowerCase().includes(searchText.toLowerCase()))
        return (
            <div style={{ position: "relative" }}>
                {this.state.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    <div>
                        {(permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.AddFile) ||
                            this.props.loggedInUserType === ELoggedInUserType.Employee) &&
                            <FloatingActionButton
                                data-intercom-target={"menu-Employees-Devices-Btn-Add"}
                                style={{ position: "relative", float: "right", right: 50, top: -45 }}
                                secondary
                                onTouchTap={() => this.setState({ openUploadFileDialog: true })}
                            >
                                <ContentAdd />
                            </FloatingActionButton>
                        }
                        <TableActionBar
                            rowSelectionCount={this.state.selectedFile ? 1 : 0}
                            singleSelectedMessage={strings.File_Selected}
                            multipleSelectedMessage={strings.x_Files_Selected}
                            title={strings.Files}
                            onSearch={searchText => this.setState({ searchText, offset: 0, selectedFile: null })}
                            searchText={""}
                            onDeleteClick={this.deleteFile}
                        />
                        {filteredFiles.length === 0 ?
                            <h2 style={{ textAlign: "center" }}>{strings.No_File}</h2> :
                            <UserDetailsFilesTable
                                readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.DeleteFile) &&
                                    this.props.loggedInUserType !== ELoggedInUserType.Employee}
                                files={filteredFiles}
                                selectedFile={this.state.selectedFile}
                                total={this.state.total}
                                offset={this.state.offset}
                                limit={this.state.limit}
                                limitOptions={[20, 50, 100]}
                                onPageClick={offset => this.setState({ offset }, () => this.getFiles())}
                                onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.getFiles())}
                                handleSelectFile={selectedFile => this.setState({ selectedFile })}
                            />
                        }
                    </div>
                }
                {this.state.openUploadFileDialog &&
                    <UploadUserDetailsFileDialog
                        handleSave={file => {
                            AppStateStore.setProgressSnackbarContent("loading")
                            api.addEmployeeFile(this.props.userId, file)
                                .then(() => {
                                    this.setState({ offset: 0, searchText: "" }, () =>
                                        this.getFiles()
                                    )
                                    AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
                                })
                        }}
                        handleClose={() => this.setState({ openUploadFileDialog: false })}
                    />
                }
            </div>
        )
    }
} 